/* tslint:disable */

/**
 */
export class Category {
    id?: number;
    type?: string;
    display_name?: string;
    created_at?: string;
    updated_at?: string;
    parent_id?: number;
    description?: string;
    deleted_at?: string;
    key?: string;
}
